import React, { Fragment, useEffect, useState } from 'react'
import Modal from '@material-ui/core/Modal';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import FormAddPayment from '../../../../Payments/components/FormAddPayment';
import { formatNumber } from '../../../../Utils/Money';
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import ChipShowRetentionToInvoice from '../../../../Payments/components/ChipShowRetentionToInvoice';

const AddPaymentToInvoice = ({ selectedInvoice }) => {

    const [paymentsByInvoice, setPaymentsByInvoice] = useState(null);
    const [incomeToPay, setIncomeToPay] = useState(0);
    const [invoice, setInvoice] = useState(null);
    const [totalInvoice, setTotalInvoice] = useState(0);
    const [retentionsToInvoice, setRetentionsToInvoice] = useState(null); // Retenciones creadas a la factura
    const [totalValueFromRetentionsToInvoice, setTotalValueFromRetentionsToInvoice] = useState(0) //Suma de todas las retenciones a la factura


    useEffect(() => {
        /* if(selectedInvoice !== null && selectedInvoice !== undefined){
            goToInvoice(selectedInvoice.num_fac_ter);
        } */
        getPaymentById();

    }, [])

    useEffect(() => {
        calculateValueToPay();
    }, [paymentsByInvoice, retentionsToInvoice])

    const goToInvoice = async (num_fac_ter) => {
        try {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-por-numero', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ num_fac_ter: num_fac_ter })
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.factura != null) {
                    let factura = data.factura;
                    setInvoice(factura);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
        catch (e) {
            console.log(e);
        }
    }

    //pagos/consultar?id_factura_t=
    const getPaymentById = async () => {
        let id_factura = selectedInvoice.id_factura_t;

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/consultar?id_factura_t=' + id_factura, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("PAYMENTSBYINVOICE", data);
                //setPaymentsByInvoice(data);
                filterPayments(data);
                goToInvoice(selectedInvoice.num_fac_ter)
            })
            .catch((error) => {
                console.log(error)
            })
    };

    //discrimina los pagos de las retenciones
    const filterPayments = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== true);
            setPaymentsByInvoice(resul);
        }
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== false);
            setRetentionsToInvoice(resul);
        }
    }

    const stateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return 'POR PAGAR';
            } else if (parseInt(stateInvoice) === 2) {
                return 'PAGADA PARCIALMENTE';
            } else if (parseInt(stateInvoice) === 3) {
                return 'PAGADA COMPLETAMENTE';
            } else if (parseInt(stateInvoice) === 4) {
                return 'RETRASADA';
            } else if (parseInt(stateInvoice) === 5) {
                return 'SOBREPAGO';
            }
        } else {
            return 'POR PAGAR';
        }
    }
    const colorStateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return '#0084CF';
            } else if (parseInt(stateInvoice) === 2) {
                return '#FFA600';
            } else if (parseInt(stateInvoice) === 3) {
                return '#48CF00';
            } else if (parseInt(stateInvoice) === 4) {
                return '#FF2D00';
            } else if (parseInt(stateInvoice) === 5) {
                return '#6B00CF';
            }
        } else {
            return '#0084CF';
        }
    }

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        console.log("TOTALFACEN", invoice)
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }

    const calculateValueToPay = async () => {
        if (paymentsByInvoice !== null && paymentsByInvoice !== undefined) {
            console.log("PAY", paymentsByInvoice)
            let sumRetentions = 0;
            if (retentionsToInvoice !== null && retentionsToInvoice !== undefined) {
                let sumRet = calculateRetentionsValueToInvoice(retentionsToInvoice);
                console.log("sumRET", sumRet);
                sumRetentions = sumRet;
            }
            let valueTotal = calculateTotal(selectedInvoice);
            let valot_total_fac = valueTotal?.total_tercero;
            let sumPayments = addPayments(paymentsByInvoice);
            let incomeToPay = valot_total_fac - sumPayments - sumRetentions;
            setIncomeToPay(incomeToPay);
        }
    }

    const addPayments = (data) => {
        let acc = 0;
        data.forEach((element) => {
            acc += element.importe;
        })
        return acc;
    }

    //calcula el monto de todas las retenciones creadas a la factura 
    const calculateRetentionsValueToInvoice = (retentions) => {
        let valueFromRetentions = 0;
        if (retentions !== null && retentions !== undefined) {
            retentions.forEach((ret) => valueFromRetentions += ret.importe)
        }
        setTotalValueFromRetentionsToInvoice(valueFromRetentions);
        return valueFromRetentions;
    }


    return (
        <Fragment>
            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    {
                        paymentsByInvoice !== null && paymentsByInvoice !== undefined ?
                            paymentsByInvoice.map((payment) => (
                                <Card key={payment.id_pago} style={{ border: '1px solid #55e5bb', margin: '0em 0.5em' }}>
                                    <Row sm={12} style={{ padding: '0em 0.25em', margin: '0.25em 0.25em' }}>
                                        <Col>
                                            <h4><b>PAGO No. {payment.id_pago}</b></h4>
                                        </Col>
                                        <Col>
                                            <h5><b>FACTURA. {payment.num_fac_ter}</b></h5>
                                        </Col>
                                    </Row>
                                    <hr style={{ color: '#55e5bb', margin: '0em 0.5em' }}></hr>
                                    <Row style={{ padding: '0em 0.25em', margin: '0.25em 0.25em' }}>
                                        <Col>
                                            <h4><b>IMPORTE: ${formatNumber(payment.importe)}</b></h4>
                                            <p style={{ margin: '0.25em 0em' }}><b>Fecha:</b> {moment(payment.fecha_pago).format('DD-MM-YYYY')} - <b>Forma de Pago:</b> {payment.forma_pago} - <b>Transacción:</b> {payment.transaccion}</p>
                                            <p style={{ margin: '0.25em 0em' }}>Nota: {payment.nota}</p>
                                        </Col>
                                    </Row>
                                </Card>
                            ))
                            : null
                    }
                </div>

                {
                    invoice !== null && invoice !== undefined ?
                        <Fragment>
                            <Row>
                                <Col md={12}>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', margin: '1em 0em' }}>
                                        <div><h4 style={{ margin: '1em 0em' }}><b>{/* {onEdit ? 'ACTUALIZAR' : 'REGISTRAR'} */} REGISTRAR PAGO A LA FACTURA {invoice.num_fac_ter}</b></h4></div>
                                        <div><p><b>Estado: </b><span style={{ color: colorStateInvoice(invoice.estado_pago) }}><FontAwesomeIcon icon={faCircle} style={{ color: colorStateInvoice(invoice.estado_pago) }} /> {stateInvoice(invoice.estado_pago)}</span></p></div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '1em 0em' }}>
                                        <div><p><b>Cliente: </b>{invoice.nombre_facturado}</p></div>
                                        <div><p><b>Total de la Factura: $</b>{formatNumber(totalInvoice)}</p></div>
                                        <div><p><b>Fecha de Emisión: </b>{moment(invoice.fecha_emision_format).format('DD-MM-YYYY')}</p></div>
                                        <div><p><b>Importe a Pagar: $ {formatNumber(incomeToPay)}</b></p></div>
                                    </div>
                                    <Row>
                                        {retentionsToInvoice &&
                                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
                                                {retentionsToInvoice.length > 0 ?
                                                    <Fragment>
                                                        <div><h5><b>RETENCIONES: </b></h5></div>
                                                        <div>
                                                            {
                                                                retentionsToInvoice.map((ret) => (
                                                                    <ChipShowRetentionToInvoice retention={ret} />
                                                                ))
                                                            }
                                                        </div>
                                                        <div><h5><b>= ${formatNumber(totalValueFromRetentionsToInvoice)}</b></h5></div>
                                                    </Fragment>
                                                    : null}
                                            </div>
                                        }
                                    </Row>
                                    <hr style={{ color: '#55e5bb' }}></hr>
                                    {/* <FormAddPayment refresh={getPayments} invoice={invoice} paymentToEdit={paymentToEdit} onEdit={onEdit} /> */}
                                    <FormAddPayment refresh={getPaymentById} selectedInvoice={invoice} onEdit={false} paymentToEdit={null} incomeToPay={incomeToPay} />
                                </Col>
                            </Row>
                        </Fragment>
                        :
                        <div className="text-center">
                            <br /><br /><br />
                            <div class="load__icon-wrap">
                                <svg class="load__icon">
                                    <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                </svg>
                            </div>
                            <br /><br /><br />
                        </div>
                }
            </div>
        </Fragment>
    )
}

export default AddPaymentToInvoice